import { useEffect, useMemo } from "react";
import { useMap } from "react-map-gl";
import { useMapboxDraw } from "../DrawToolProvider";
import { getAcreage, getArea } from "../DrawToolProvider/_draw.helpers";
import { useDispatch, useSelector } from "react-redux";
import { inputsActions } from "../..";
import { usePrevious } from "../..";

const HandleFeatureUpdate = ({ feature }) => {
  const dispatch = useDispatch();
  const { current: mapRef } = useMap();
  const map = mapRef.getMap();
  const draw = useMapboxDraw();

  // const loading = useSelector((state) => state.projects.loading);
  // const loaded = useSelector((state) => state.projects.loaded);

  // const prev_loading = usePrevious(loading);
  // const prev_loaded = usePrevious(loaded);
  // const just_loaded = loading === false && prev_loaded === undefined;

  // useEffect(() => {
  //   console.log(" cur", loaded, loading);
  //   console.log("prev", prev_loaded, prev_loading);
  // }, [loaded, loading]);

  const memoizedFeature = useMemo(() => feature, [feature]);

  useEffect(() => {
    if (!map || !draw || !memoizedFeature) return;
    // console.log("the memorized feature:", memoizedFeature);
    map.on("draw.update", handleUpdate);

    map.once("idle", () => {
      selectFeatureOnMap(memoizedFeature.properties.index);
    });

    return () => {
      map.off("draw.update", handleUpdate);
    };
  }, [map, memoizedFeature, memoizedFeature.properties.identity]);

  const handleUpdate = (e) => {
    if (e.features[0].properties.shape !== "siteFeature") return;
    // console.log("updating feature", e.features[0]);
    if (e.features[0].properties.index === feature.properties.index) {
      let geoJson = e.features[0];
      geoJson.properties["area"] = getArea(geoJson.geometry.coordinates);
      geoJson.properties["acreage"] = getAcreage(geoJson.geometry.coordinates);
      dispatch(inputsActions.update_site_input("edit_site_feature", geoJson));
      draw.delete(e.features[0].id);
      selectFeatureOnMap(e.features[0].id);
    }
  };

  const selectFeatureOnMap = (id) => {
    draw.changeMode("simple_select", { featureIds: id });
  };

  return null;
};

export { HandleFeatureUpdate };
